export default "__VITE_ASSET__B$IuuMFs__"